import { NgModule } from '@angular/core';
import { SafeCommentPipe } from './safe-comment.pipe';
import { ImagePathPipe } from './image-path.pipe';
import { CustomDatePipe } from './custom-date.pipe';
import { IndainNumberPipe } from './indain-number.pipe';

@NgModule({
    declarations: [
        SafeCommentPipe,
        ImagePathPipe,
        CustomDatePipe,
        IndainNumberPipe
    ],
    exports     : [
        SafeCommentPipe,
        ImagePathPipe,
        CustomDatePipe,
        IndainNumberPipe
    ]
})
export class AllPipeModule
{
}